import Vue from 'vue';
import constants from 'Helpers/constants';
import { eventBus } from '~/app';
import store from '~/store';
import axios from 'axios';
import utils from 'Helpers/utils';

export default {
    namespaced: true,
    state: {
        config: {},
        messages: [],
        bets: [],
        orders: [],
        // favoriteGameOrderById: undefined,
        favoriteEvent: {},
        favoriteEventProcessing: {},
        lang: null,
        ccy: null,
        //isInitialized, if false, server will return notifications, balance etc. See Middleware/AppData.php
        isInitialized: false,
        isBrowserTabInactive: false, //we change it when player leave app tab to another
        lastBrowserTabInactive: null,
    },
    mutations: {
        setIsBrowserTabInactive(state, value) {
            state.isBrowserTabInactive = value;
            if (value) {
                state.lastBrowserTabInactive = Date.now();
            } else {
                state.lastBrowserTabInactive = null;
            }
        },
        setConfig(state, config) {
            state.config = config;
        },

        setLang(state, lang) {
            state.lang = lang;
        },

        setCcy(state, ccy) {
            state.ccy = ccy;
        },

        setFavoriteEvent(state, favoriteEvent) {
            //for some reason we can't receive empty object, only array
            if (_.isEmpty(favoriteEvent)) {
                state.favoriteEvent = {};
            } else {
                state.favoriteEvent = favoriteEvent;
            }
        },

        setFavoriteEventProcessing(state, favoriteEventProcessing) {
            state.favoriteEventProcessing = favoriteEventProcessing;
        },

        // setFavoriteGameOrderById(state, favoriteGameOrderById) {
        //     localStorage.setItem('BoardModuleOrderBy', favoriteGameOrderById);
        //     state.favoriteGameOrderById = favoriteGameOrderById;
        // },

        setBets(state, bets) {
            let filteredBets = [];
            filteredBets = bets.filter((bet) => {
                return bet.period_type_id === constants.EVENT_PERIOD_FT || (bet.event_is_ht_already === 0 && bet.event_is_2nd_half_started === 0);
            });
            state.bets = filteredBets;
            let betCustomGamesIds = [];
            Object.entries(state.bets).forEach(([, bet]) => {
                betCustomGamesIds.push(bet.custom_event_id);
                if (bet.status_id === constants.BET_STATUS_REJ) {
                    setTimeout(
                        () =>
                            this.dispatch('AppModule/removeBet', bet, {
                                root: true,
                            }),
                        60000
                    );
                }
            });

            eventBus.$emit('betsLoaded', betCustomGamesIds);
        },

        setOrders(state, orders) {
            state.orders = orders;
        },

        setToolUserSettings(state, toolUserSettings) {
            return (state.config.toolUserSettings = toolUserSettings);
        },

        setMinStakes(state, minStakes) {
            return (state.config.minStakes = minStakes);
        },

        setMessages(state, message) {
            if (_.isArray(message)) {
                state.messages = message;
            } else {
                state.messages.push(message);
            }
        },
    },
    getters: {
        getIsBrowserTabInactive(state) {
            return state.isBrowserTabInactive;
        },

        getLastBrowserTabInactive(state) {
            return state.lastBrowserTabInactive;
        },

        getConfig(state) {
            return state.config;
        },

        getLang(state) {
            return state.lang;
        },

        getCcy(state) {
            return state.ccy;
        },

        getFavoriteEvent(state) {
            return state.favoriteEvent;
        },

        getFavoriteEventProcessing(state) {
            return state.favoriteEventProcessing;
        },

        // getFavoriteEventOrderById(state) {
        //     return state.favoriteEventOrderById;
        // },

        getBets(state) {
            return state.bets;
        },

        getBetsByParams: (state) => (params) => {
            return state.bets.filter(function (bet) {
                let conditions = true;

                Object.keys(params).forEach((key) => {
                    if (bet[key] !== undefined) {
                        conditions = conditions && bet[key] == params[key];
                    }
                });

                return conditions;
            });
        },

        getOrdersByParams: (state) => (params) => {
            return state.orders.filter(function (bet) {
                let conditions = true;

                Object.keys(params).forEach((key) => {
                    if (bet[key] !== undefined) {
                        conditions = conditions && bet[key] == params[key];
                    }
                });

                return conditions;
            });
        },

        getOrders(state) {
            return state.orders;
        },

        getToolUserSettings(state) {
            return state.config.toolUserSettings ? state.config.toolUserSettings : {};
        },

        getMinStakes(state) {
            let user = store.getters['UserModule/getUser'];
            return state.config.minStakes[user.currency];
        },
    },
    actions: {
        clearFavoriteEvents(context, data) {
            Vue.set(context.state, 'favoriteEvent', {});

            return axios.post('/api/favoriteEvent/clear', {});
        },

        toggleFavoriteEvent(context, data) {
            //we use favoriteEventProcessing for disable extra click to start icon to avoid wrong request
            if (data.item.ceId in context.state.favoriteEventProcessing) {
                return false;
            }

            Vue.set(context.state.favoriteEventProcessing, data.item.ceId, true);

            if (context.state.favoriteEvent[data.item.ceId]) {
                Vue.delete(context.state.favoriteEvent, data.item.ceId);

                axios
                    .post('/api/favoriteEvent/delete', {
                        rows: [{ id: data.item.ceId }],
                    })
                    .then((response) => {
                        Vue.delete(context.state.favoriteEventProcessing, data.item.ceId);
                    });
            } else {
                Vue.set(context.state.favoriteEvent, data.item.ceId, 1);
                axios
                    .post('/api/favoriteEvent/create', {
                        rows: [{ ceId: data.item.ceId }],
                    })
                    .then((response) => {
                        Vue.delete(context.state.favoriteEventProcessing, data.item.ceId);
                    });
            }
        },

        // addFavorite(context, favorite) {
        //     context.state.favoriteEvent.push(favorite.custom_event_id);
        // },

        // updateFavorite(context, favorite) {
        //     context.state.favoriteEvent.push(favorite.custom_event_id);
        // },

        // deleteFavorite(context, favorite) {
        //     let index = context.state.favoriteEvent.indexOf(favorite.custom_event_id);
        //     context.state.favoriteEvent.splice(index, 1);
        // },

        addBet(context, bet) {
            context.state.bets.unshift(bet);
            if (bet.status_id === constants.BET_STATUS_REJ) {
                setTimeout(
                    () =>
                        this.dispatch('AppModule/removeBet', bet, {
                            root: true,
                        }),
                    60000
                );
            }

            //we need to reload order page to update order status to correct
            if (bet.status_id === constants.BET_STATUS_WAIT && _.isNumber(bet.betOrderId)) {
                eventBus.$emit('orderUpdated', { id: bet.betOrderId });
            }

            eventBus.$emit('betAdded', bet.custom_event_id);
        },

        updateBet(context, data) {
            let betIndex = context.state.bets.findIndex((bet) => bet.id == data.id);
            let bet = Object.assign({}, context.state.bets[betIndex], data);

            if (bet.status_id == constants.BET_STATUS_ABN || bet.status_id == constants.BET_STATUS_VOID) {
                Vue.delete(context.state.bets, betIndex);
            } else {
                Vue.set(context.state.bets, betIndex, bet);
            }

            if (bet.status_id === constants.BET_STATUS_REJ) {
                setTimeout(
                    () =>
                        this.dispatch('AppModule/removeBet', bet, {
                            root: true,
                        }),
                    60000
                );
            }

            eventBus.$emit('betUpdated', data.custom_event_id);
        },

        removeBet(context, bet) {
            let betIndex = context.state.bets.findIndex((b) => b.id === bet.id);
            Vue.delete(context.state.bets, betIndex);
            eventBus.$emit('betUpdated', bet.custom_event_id);
        },

        addOrder(context, data) {
            context.state.orders.unshift(data);
            eventBus.$emit('orderAdded', data);
        },

        updateOrder(context, data) {
            let betIndex = context.state.orders.findIndex((order) => order.id == data.id);
            let order = Object.assign({}, context.state.orders[betIndex], data);

            if (order.status_id === constants.ORDER_STATUS_CLOSED_ID) {
                if (order.stats) {
                    var msg = '';
                    let color = 'greenMsg';

                    if (order.stats.fill_percent === 0) {
                        msg = store.$i18n.t('betOrder.popup.notFilled', {
                            id: order.internal_id,
                        });
                        color = 'lightRedMsg';

                        let info = utils.bettingInfoForMessage(order, true, '');

                        msg += info.gameInfo ? '<br>' + info.gameInfo : '' + info.betInfo ? '<br>' + info.betInfo : '';
                    } else {
                        if (order.stats.fill_percent === 100) {
                            msg = store.$i18n.t('betOrder.popup.fullyFilled', {
                                id: order.internal_id,
                            });
                        } else {
                            msg = store.$i18n.t('betOrder.popup.partialFilled', {
                                id: order.internal_id,
                                percent: order.stats.fill_percent,
                            });
                            color = '#92c47dcc';
                        }

                        if (order.stats.odds && order.odds_requested) {
                            let oddsDiff = parseFloat(order.stats.odds) - parseFloat(order.odds_requested);
                            if (oddsDiff >= 0.01) {
                                msg +=
                                    '<br>' +
                                    store.$i18n.t('betOrder.popup.takenBetterOdds', {
                                        oddsDiff: oddsDiff.toFixed(3),
                                    });
                            }
                        }
                    }

                    utils.orderClosedMessage(msg, color);
                }

                Vue.delete(context.state.orders, betIndex);
            } else {
                Vue.set(context.state.orders, betIndex, order);
            }

            eventBus.$emit('orderUpdated', data);
        },
    },
};
